 <ng-container *ngIf="result?.comments">
    <p class="average mb-0 d-flex align-items-center mt-2" style="margin-left: 3em">
      <span class="d-flex align-items-center" *ngIf="result?.comments?.averageStars > 0">
      <span style="display: flex; justify-content: center; align-items: center;background-color: black;border-radius: 50%;width: 26px;height:26px"
            [ngStyle]="{'color': clientsSettingAppBooking?.clients_setting_global?.color_main_1}">{{result?.comments?.averageStars * 2}}</span>
      <span *ngIf="result?.comments?.averageStars > 0" style="margin-left: 5px;font-style: italic"
             [ngStyle]="{'color': clientsSettingAppBooking?.clients_setting_global?.color_main_1}" >{{getCommentadjective(result?.comments?.averageStars)}}</span>
      </span>
      <span *ngIf="result?.comments?.averageStars === 0" style="height: 26px"></span>
      <span class="rubik-regular-12pt" style="font-style: italic" [ngStyle]="{'color': result?.comments?.averageStars > 0 ? clientsSettingAppBooking?.clients_setting_global?.color_main_1 : '#bbbbbb',
                                      'margin-left': result?.comments?.averageStars > 0 ? '3px' : ''}">  {{result?.comments?.averageStars > 0 ? 'puntuación' : 'Sin puntuación'}}</span>
    </p>
</ng-container>

<div class="d-flex align-items-center" style="height: 60px;">

  <div class="d-flex justify-content-start" style="height: auto; width: 100%;margin-left: 2em;">
    <img src="../../../../../assets/icons/search-result/tiempo_uso.svg" style="width: 26px;margin-bottom: 2px"  alt="">
      <div class="d-flex flex-column" style="margin-left: 4px">
        <p class="mb-0 rubik-regular-12pt"> Duración:</p>
        <p class="mb-0 rubik-regular-12pt" style="font-weight: 500; color:black">
          {{ getDurations(result) !== '' ? getDurations(result) : 'N/A' }}
        </p>
      </div>
    </div>
    <div  class="d-flex justify-content-start" style="height: auto;width:100%">
      <i class="fa fa-clock-o" style="font-size: 1.2rem" aria-hidden="true" ></i>
      <span *ngIf="periodsActivities(result) !== ''">
        <div class="d-flex flex-column " style="margin-left: 4px">
          <p class="mb-0 rubik-regular-12pt">Horarios:</p>
        </div>
        <div class="d-flex align-items-center" style="gap: 2px;margin-left: 4px">
          <p class="mb-0 rubik-regular-12pt" style="font-weight: 500; color:black">
            {{ periodsActivities(result) }}
          </p>
        </div>
      </span>
      <span *ngIf="periodsActivities(result) === ''">
        <div class="d-flex flex-column" style="margin-left: 4px">
          <p class="mb-0 rubik-regular-12pt">Horarios:</p>
        </div>
        <div class="d-flex align-items-center" style="gap: 2px;margin-left: 4px">
          <p class="mb-0 rubik-regular-12pt" style="font-weight: 500; color:black">
          N/A
          </p>
       </div>
      </span>
    </div>
  </div>
  <ng-container *ngIf="result.description">
  <div  class="d-flex pr-4" style=" margin-left:2em">
     <div  class="description pt-1 d-flex flex-column">
      <p class="mb-0 rubik-regular-12pt" style="min-height:40.56px;line-height: 1.2;">{{result.description | truncate : 120 : "  "}}
        <a (click)="openModal('info');" class="rubik-regular-12pt" style="cursor: pointer;font-weight: 500!important;  font-family: 'Rubik', sans-serif!important;font-size: 0.75rem;color: #666666;line-height: 1;">...más</a> </p>
    </div>
  </div>
  </ng-container>
  <ng-container *ngIf="result.description === ''">
    <div class=" pr-4 mt-3 py-2 " style="border-top: .5px solid #cccccc;min-height:40.56px">
      <p class="rubik-regular-12pt mb-0 pr-2" style="margin-left:3em;line-height: 1.2;height:40.56px">
        No hay información acerca de este hotel.
      </p>
    </div>
  </ng-container>
  <div class="d-flex align-items-center mt-3" style="border-top: .5px solid #cccccc; height: 67px">
    <div *ngIf="getLanguages(result) !== ''"  class="d-flex flex-column justify-content-center  py-2" style="height: 100%;width:100%;margin-left: 2em">

       <div class="d-flex flex-column">
          <p class="mb-1 rubik-regular-12pt" style="font-weight: 600;color: black">Idioma</p>
        </div>
      <div class="ml-1 d-flex align-items-center" style="gap:3px">
       <img #icon src="../../../../../assets/icons/search-result/tour/idioma.svg" style="width: 28px;height: 24px;opacity: .5;" alt="">
        <div class="d-flex align-items-center" style="gap: 2px; margin-bottom: 4px">
          <span *ngFor="let language of getLanguageArray(result?.additionalInfo?.tours?.options)">
            <img src="{{getFlagByLanguageName(language)}}"
                                            [tooltip]="language"
                                            aria-hidden="true"
                                            placement="bottom"
                                      style="width: 16px;height:16px; border-radius: 1px;border-radius: 2px;margin-top: 2px" alt="">
          </span>
        </div>
      </div>
    </div>
    <div *ngIf="getLanguages(result) === ''"  class="d-flex flex-column justify-content-center py-2 pl-1" style="height: 100%;width:100%;margin-left: 2em;">
                         <div class="d-flex flex-column">
                                <p class="mb-1 rubik-regular-12pt" style="font-weight: 600;color: black">Idioma</p>
                            </div>


                        <span class="ml-1 d-flex align-items-center" style="gap:3px">
                           <img #icon src="../../../../../assets/icons/search-result/tour/idioma.svg" style="width: 24px;opacity: .5;" alt="">
                            <div class="d-flex align-items-center" style="gap: 2px;">
                              <p class="mb-0 rubik-regular-12pt" style="color:black">
                                N/A
                              </p>
                          </div>
                        </span>
                    </div>

                    <div class="py-2 d-flex align-items-center" style="height: 100%;width: 100%; border-left: .5px solid #cccccc">
                      <div class="d-flex flex-column" style="margin-left: 1em">
                                <p class="mb-2 rubik-regular-12pt" style="font-weight: 600;color: black">Adicionales</p>
                             <ng-container *ngIf="getAddons(result?.additionalInfo?.tours?.extras) && getAddons(result?.additionalInfo?.tours?.extras).length > 0">
                              <ng-container *ngFor="let addons of getAddons(result?.additionalInfo?.tours?.extras)">
                                  <ng-container *ngIf="addons?.type === 'Cargo de Traslado'">
                                      <img
                                        [src]="addons?.image"
                                        style="width: 22px;"
                                        [tooltip]="addons?.tooltip"
                                        placement="bottom"
                                        alt="addon icon">
                                  </ng-container>
                              </ng-container>
                            </ng-container>
                            <ng-container *ngIf="getAddons(result?.additionalInfo?.tours?.extras) && getAddons(result?.additionalInfo?.tours?.extras).length === 0">
                              <p class="mb-0 rubik-regular-12pt" style="color:black">
                                N/A
                              </p>
                            </ng-container>
                              </div>

                    </div>
                </div>
